/* global document, window, localStorage */

/**
 * Header cart + wishlist badges.
 *
 * Cart count is rendered server-side from WC()->cart and refreshed via
 * WooCommerce's `woocommerce_add_to_cart_fragments` hook (registered in
 * app/wc-template-hooks.php). When the AJAX add-to-cart fragment swaps
 * `[data-cart-count]`, the new node arrives with the correct count and
 * hidden state baked in — no JS needed here for the cart side.
 *
 * Wishlist count is fully client-side: read from localStorage, updated
 * whenever the wishlist toggles (single-product.js dispatches
 * `icf:wishlist-changed`) and across tabs via the native `storage` event.
 */
( function () {
	const WL_KEY = 'icfWishlistIds';

	const onReady = ( fn ) => {
		if ( document.readyState !== 'loading' ) {
			fn();
		} else {
			document.addEventListener( 'DOMContentLoaded', fn );
		}
	};

	const loadWishlistIds = () => {
		try {
			const raw = localStorage.getItem( WL_KEY );
			const arr = raw ? JSON.parse( raw ) : [];
			return Array.isArray( arr ) ? arr : [];
		} catch ( err ) {
			return [];
		}
	};

	const syncWishlistBadges = ( ids ) => {
		const count = ids.length;
		document.querySelectorAll( '[data-wish-count]' ).forEach( ( el ) => {
			el.textContent = String( count );
			if ( count > 0 ) {
				el.removeAttribute( 'hidden' );
			} else {
				el.setAttribute( 'hidden', '' );
			}
		} );
	};

	const init = () => {
		if ( ! document.querySelector( '[data-wish-count]' ) ) {
			return;
		}

		syncWishlistBadges( loadWishlistIds() );

		// Reflect changes from the existing wishlist toggle in single-product.js.
		document.addEventListener( 'icf:wishlist-changed', ( e ) => {
			const ids = ( e.detail && Array.isArray( e.detail.ids ) ) ? e.detail.ids : loadWishlistIds();
			syncWishlistBadges( ids );
		} );

		// Cross-tab sync.
		window.addEventListener( 'storage', ( e ) => {
			if ( e.key === WL_KEY ) {
				syncWishlistBadges( loadWishlistIds() );
			}
		} );
	};

	onReady( init );
}() );
